var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import * as R from "ramda";
import { DATAFLOW_ANNOTATIONS_PATH, DEFAULT_ANNOT_TYPE, DEFAULT_PARAMS, DEFAULT_LASTNOBS_VAL } from "./constants/annotations.mjs";
import { LASTNOBS_PARAM_KEY } from "./constants/params.mjs";
const parseDefaultAnnotation = (structure) => R.pipe(
  R.pathOr([], DATAFLOW_ANNOTATIONS_PATH),
  R.find(R.propEq(DEFAULT_ANNOT_TYPE, "type")),
  R.ifElse(R.isNil, R.always({}), R.identity),
  R.propOr("", "title"),
  R.split(","),
  R.reduce((acc, entry) => {
    const splitEntry = R.pipe(
      R.split("="),
      R.ifElse(
        R.pipe(R.head, R.flip(R.has)(DEFAULT_PARAMS)),
        R.over(R.lensIndex(0), R.flip(R.prop)(DEFAULT_PARAMS)),
        R.identity
      ),
      R.ifElse(
        R.allPass([
          R.pipe(R.length, R.equals(1)),
          R.pipe(R.head, R.equals(LASTNOBS_PARAM_KEY))
        ]),
        R.append(DEFAULT_LASTNOBS_VAL),
        R.identity
      )
    )(entry);
    return __spreadProps(__spreadValues({}, acc), {
      [R.head(splitEntry)]: R.last(splitEntry)
    });
  }, {})
)(structure);
export {
  parseDefaultAnnotation
};
